import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedBox,
  ExtendedFlex,
  Heading,
  Body,
  InlineTextLink,
  RecentInvestmentCard,
  CarouselRecentInvestments,
  VisibilitySensor,
  Theme,
} from '../../coreui';

import recentInvestmentsData from './recentInvestmentsData';
import FadeIn from '../../components/FadeIn';
import BrowseLink from '../../components/BrowseLink';

class RecentInvestments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };

    this.handleSensorChange = this.handleSensorChange.bind(this);
  }

  handleSensorChange(isVisible) {
    if (isVisible) {
      this.setState({
        isVisible,
      });
    }
  }

  render() {
    const { isVisible } = this.state;

    const {
      title,
      subtitle,
      smartBtn,
      bgColor,
      isLoggedIn,
    } = this.props;

    return (
      <ExtendedBox
        bg={bgColor}
        py={[100, 100, 100, 160, 220]}
      >
        <ExtendedFlex
          flexDirection="column"
          align="Center"
          mb={[20, 30, 40, 60, 80]}
        >
          <VisibilitySensor
            callback={this.handleSensorChange}
          />
          <FadeIn>
            <Heading
              type="H9"
              m={0}
              display="block"
              textAlign="center"
              opacity={isVisible ? '1' : '0'}
            >
              {title}
            </Heading>
            <Heading
              type="H8"
              display="block"
              textAlign="center"
              mx={[30, 20, 0, 0, 0]}
              opacity={isVisible ? '1' : '0'}
            >
              {subtitle}
            </Heading>
          </FadeIn>
        </ExtendedFlex>
        <ExtendedFlex
          flexDirection="column"
          align="Center"
          maxWidth="100%"
          mb={80}
        >
          <Body
            type="B2"
            m={0}
            display="block"
            textAlign="center"
            width={[0.75, 500, 500, 500, 620]}
          >
            Investments on RealtyMogul are illiquid and loss of invested capital is possible.
            Please review risk factors for private placements{' '}
            <InlineTextLink
              href="https://www.realtymogul.com/materials/riskswheninvestinginprivateplacements.pdf"
              target="_blank"
            >
              here
            </InlineTextLink>
            .
          </Body>
          <VisibilitySensor
            callback={this.handleSensorChange}
          />
        </ExtendedFlex>
        <ExtendedBox>
          <CarouselRecentInvestments>
            {
              recentInvestmentsData.map(
                (data, index) => {
                  return (
                    <ExtendedBox
                      key={data.id}
                      mx={5}
                    >
                      <RecentInvestmentCard
                        image={data.image}
                        title={data.label}
                        location={`${data.address.locality}, ${data.address.administrative_area}`}
                        propertyType={data.propertyType}
                        investmentType={data.investmentType}
                        description={data.blurb}
                        opacity={isVisible ? '1' : '0'}
                        transition={`
                          opacity ${Theme.fadeInDelay}ms ${!isVisible ? '0' : (5 + index) / 10}s linear
                        `}
                      />
                    </ExtendedBox>
                  );
                },
              )
            }
          </CarouselRecentInvestments>
        </ExtendedBox>
        {smartBtn &&
          <ExtendedBox
            mt={[65, 75, 0, 0, 0]}
            pl={12}
          >
            <BrowseLink
              isLoggedIn={isLoggedIn}
            />
          </ExtendedBox>
        }
      </ExtendedBox>
    );
  }
}

RecentInvestments.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  smartBtn: PropTypes.bool,
  bgColor: PropTypes.string,
  isLoggedIn: PropTypes.bool,
};

RecentInvestments.defaultProps = {
  title: 'Recent Investments',
  subtitle: 'Investment confidence is built on past performance',
  smartBtn: false,
  bgColor: 'gray.0',
  isLoggedIn: false,
};

export default RecentInvestments;
